// extracted by mini-css-extract-plugin
module.exports = {"backlink":"back-link-v2_backlink__3R_wc","backlinkContent":"back-link-v2_backlinkContent__3MXpg","icon":"back-link-v2_icon__QtCIz","text":"back-link-v2_text__3urq3"};